module.exports = __webpack_public_path__ + "static/media/advisor-2@3x.9bdb5605.jpg";